<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-card :bordered="false">
      <a-tabs v-model:activeKey="activeKey" @change="changeTab">
        <a-tab-pane key="first" tab="搜索"></a-tab-pane>
        <a-tab-pane key="second" tab="按ID批量选择"></a-tab-pane>
      </a-tabs>
      <div v-if="activeKey === 'first'">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper" >
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品编号')" prop="id">
                  <a-input v-model="queryParam.id" :maxLength="20" :placeholder="$t('请输入')+$t('商品编号')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="queryParam.goodsName" :maxLength="16" :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品分类')" prop="categoryId">
                  <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                                 :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="$t('请选择')+$t('商品分类')"
                                 :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                 tree-default-expand-all allow-clear>
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商品类型" prop="goodsType">
                  <a-select :disabled="goodsType!=null" :placeholder="$t('请选择')+'商品类型'" style="width: 100%" v-model="queryParam.goodsType" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsTypeEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('学段')" prop="stage">
                  <a-select :placeholder="$t('请选择')+$t('学段')" style="width: 100%" v-model="queryParam.stage" allowClear>
                    <a-select-option v-for="(item, index) in customDict.SchoolStageEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('季节')" prop="season">
                  <a-select :placeholder="$t('请选择')+$t('季节')" style="width: 100%" v-model="queryParam.season" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsUniformSeasonEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品状态')" prop="status">
                  <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="  6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <!-- 操作 -->
        <div style="margin-bottom: 16px">
          <a-button type="primary" :disabled="this.limitNum" :loading="loading" @click="selectGoodsAll">
            全选
          </a-button>
          <a-button type="primary" :disabled="this.selectedRowKeys.length <= 0" :loading="loading" @click="reload">
            取消全部
          </a-button>
          <span style="margin-left: 8px">
            <template v-if="this.selectedRowKeys.length > 0">
              {{ `已选择 ${selectedRowKeys.length} 条` }}
            </template>
            <template v-if="this.limitNum">
               限制选择{{this.limitNum}}条
            </template>
          </span>
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :customRow="loadCustomRow"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'checkbox', onSelect: onSelect,onSelectAll:onSelectAll}"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="stage" slot-scope="text, record">
            <custom-dict-tag :options="customDict.SchoolStageEnum" :value="record.stage"/>
          </span>
          <span slot="season" slot-scope="text, record">
            <custom-dict-tag :options="customDict.GoodsUniformSeasonEnum" :value="record.season"/>
          </span>
          <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
         </span>
          <span slot="goodsType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType"/>
         </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
      <div v-if="activeKey==='second'">
        <a-row>
          <a-col :span="12" v-if="activeKey==='second'">
            <div class="prods-select-body left"  style="position: relative;">
              <a-input
                type="textarea"
                placeholder="请输入商家ID,多商家使用换行分隔，每次最多可添加2000个商家"
                v-model="idText"
                maxlength="100000"
                :rows="28"
                show-word-limit
                style="height: 600px;"
                class="textarea">
              </a-input>
              <a-button type="primary" @click="addListSecond" icon="a-icon-search" style="position: absolute;bottom: 0;right: 0;">添加</a-button>
            </div>
          </a-col>
          <a-col :span="12">
            <a-card style="margin: 0" :bordered="true">
              <div>
                <a-row>
                  <a-col :span="8"><span style="font-size: 16px">商品编号</span> </a-col>
                  <a-col :span="16"><span style="font-size: 16px">商品名称</span> </a-col>
                </a-row>
              </div>
              <div class="text item">
                <a-row v-for="(item, index) in selectedRows" :key="index">
                  <a-col :span="8">{{ item.id }}</a-col>
                  <a-col :span="14" style="width:150px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ item.goodsName }}
                  </a-col>
                  <a-col :span="2" style="float: right;">
                    <a-icon type="close" @click="deleteList(item, index)" />
                  </a-col>
                </a-row>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-card>
  </a-modal>
</template>

<script>
import {pageSelectGoods, listSelectGoods, pageSelectUniformGoods, listSelectUniformGoods} from '@/api/goods/goods'
import {platformCategoryList} from '@/api/goods/category'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {tableMixin} from '@/store/table-mixin'


export default {
  name: 'CheckboxGoodsSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      goodsType: undefined,
      index: undefined,
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      limitNum: undefined,
      selectedRowKeys: [],
      selectedRows: [],
      categoryList: [],
      cateOptions: [],
      brandList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      idText:null,
      // 查询参数
      queryParam: {
        goodsCode: null,
        goodsName: null,
        goodsType:undefined,
        merchantIdList: [],
        categoryId: null,
        orderByGoodsIdList:undefined,
        shopId: null,
        shopCategoryId: null,
        brandId: null,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        starName: null,
        prodArea: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          width: 200,
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 200,
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('学段'),
          dataIndex: 'stage',
          scopedSlots: {customRender: 'stage'},
          width: '100px',
        },
        {
          title: this.$t('季节'),
          dataIndex: 'season',
          scopedSlots: {customRender: 'season'},
          width: '100px',
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
      ]
    };
  },
  filters: {},
  created() {
    this.getCategoryList();
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    selectGoodsAll() {
      //查询该条件下所有的商品,
      listSelectGoods(this.queryParam).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
        this.onOk()
      })

      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param ids
     * @param merchantIdList 商家id列表,
     * @param index index,
     * @param goodsType
     */
    openGoods(ids, merchantIdList,goodsType,index) {
      if (merchantIdList) {
        this.queryParam.merchantIdList = merchantIdList;
      }
      if (goodsType) {
        this.goodsType =Number(goodsType)
        this.queryParam.goodsType = goodsType
      }
      if (index) {
        this.index =index
      }
      if (ids) {
        this.selectedRowKeys = ids;
        this.queryParam.orderByGoodsIdList = this.selectedRowKeys;
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsSelect', this.index,this.selectedRows)
      this.resetQueryForm()
      this.idText = null
      this.index = null
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.idText = null
      this.index = null
      this.resetQueryForm()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSelectUniformGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getCategoryList() {
      //查询平台分类
      platformCategoryList({"merchantId":0}).then(response => {
        this.categoryList = response.data
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },
    /** 重置按钮操作 */
    resetQueryForm() {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        goodsCode: null,
        goodsName: null,
        goodsType:undefined,
        merchantIdList: [],
        categoryId: null,
        orderByGoodsIdList:undefined,
        shopId: null,
        shopCategoryId: null,
        starId: this.queryParam.starId,
        brandId: null,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        starName: null,
        prodArea: null,
        pageNum: 1,
        pageSize: 10
      }
    },
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.limitNum) {
          if (this.selectedRows.length >= this.limitNum) {
            console.log('到达了限制数量,',this.limitNum)
            return false
          }
        }
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    addListSecond() {
      let param = {"idText": this.idText}
      listSelectUniformGoods(param).then(response => {
        response.data.forEach(selected => {
          //如果merchantSelectedList中没有这个商品,则添加 ,有就跳过
          if (this.selectedRows.findIndex(item => item.id === selected.id) === -1) {
            this.selectedRows.push(selected)
          }
        });
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
      });
    },
    deleteList(row, index) {
      this.selectedRows.splice(index, 1);
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            //判断是否有选择
            if (this.selectedRowKeys.includes(record.id)) {
              this.onSelect(record, false, this.selectedRows)
            } else {
              this.onSelect(record, true, this.selectedRows)
            }
          },
        }
      }
    },
  }
}
</script>
